import React from "react";
import TopCustomersTable from "../../components/Report/TopCustomersTable";

const ReportTopCustomersPage: React.FC = () => <TopCustomersTable />;
export default ReportTopCustomersPage;
